import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { Meta as MetaService } from '@angular/platform-browser';
import { CategoryViewComponentDef } from '@df/catalog-ui/category/view/category-view.component.def';
import { IProductListingConfig } from '@df/catalog-ui/listing/product-listing';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { Subject, Subscription } from 'rxjs';
import { ProductListing } from '../../../ui/listing/product-listing.decorator';
import { Category } from './../category.decorator';
import { CategoryViewLayoutComponent } from './category-view-layout.component';
// we need to check it only once
let robotsChecked = false;
@Component({
    selector: 'category-view',
    template: '<category-view-layout [variant]="model?.lpLayoutVariant" ></category-view-layout>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CategoryViewLayoutComponent]
})
export class CategoryViewComponent extends CategoryViewComponentDef<Category<ICategoryDataV3>> implements OnDestroy {
    private metaService = inject(MetaService);
    private listingSubscriptionForFacet?: Subscription;
    override listing: ProductListing | undefined;
    categoryViewModelChangeSubject = new Subject<void>();
    protected override getListingConfig(): IProductListingConfig {
        const superConfig = super.getListingConfig();
        superConfig.stockCheck = true;
        return superConfig;
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.listingSubscriptionForFacet?.unsubscribe();
    }
    protected override onModelChange(): void {
        this.listingSubscriptionForFacet?.unsubscribe();
        super.onModelChange();
        this.categoryViewModelChangeSubject.next();
        if (!robotsChecked) {
            if (this.listing) {
                this.listingSubscriptionForFacet = this.listing.subscribe(() => {
                    robotsChecked = true;
                    const facet = this.app.meta.state?.route?.data?.facet;
                    const isFacet = !!facet?.category;
                    const hasFacetRobotsOverride = !!facet?.robots;
                    if (isFacet && !hasFacetRobotsOverride && !this.listing.models?.length) {
                        this.metaService.updateTag({ name: 'robots', content: 'NOINDEX,NOFOLLOW' });
                    }
                });
            }
        }
    }
}
